import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const maxtrcp8590 = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_MaxTempJuly/MapServer/0",
    title: 'Max Temp July Change until 2090',
    opacity: 0.4,
    oraId: 'maxtrcp8590',
  })